import script from "./AlertPayloadDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertPayloadDetails.vue?vue&type=script&setup=true&lang=js"

import "./AlertPayloadDetails.vue?vue&type=style&index=0&id=47c1d36a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c1d36a"]])

export default __exports__